import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export type TrendingLocationObject = {
  [key in string]: string
}

export interface GetTrendingLocationsResponseData extends ResponseData {
  data: { [key in string]: TrendingLocationObject }
}
export interface GetTrendingLocationsResponse extends AxiosResponse {
  data: GetTrendingLocationsResponseData
}

export function getTrendingLocationsAPI(
  axiosInstance: AxiosInstance,
): Promise<GetTrendingLocationsResponse> {
  return axiosInstance({
    data: { avoidClientSideAuth: true },
    method: "get",
    url: "/home/trending-location",
  }) as Promise<GetTrendingLocationsResponse>
}
